import script from "./UpdateAccountingProductModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateAccountingProductModal.vue?vue&type=script&setup=true&lang=js"

import "./UpdateAccountingProductModal.vue?vue&type=style&index=0&id=8d008d86&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d008d86"]])

export default __exports__